// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7":"ProfilePage","897":"MainPage","970":"MessagesPage"}[chunkId] + "." + {"7":"b8da2265","897":"d466607d","970":"f42137d4"}[chunkId] + ".chunk.css";
};